/**
 * @generated SignedSource<<bc8a0e19e9b9d644207c1ba1389c2482>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectHeader_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_inner_query">;
  readonly " $fragmentType": "ProjectHeader_query";
};
export type ProjectHeader_query$key = {
  readonly " $data"?: ProjectHeader_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ProjectHeader_query",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ProjectHeader_inner_query"
    }
  ],
  "type": "Query"
};

(node as any).hash = "d1740bc312d925b4121b692ded4c84ed";

export default node;
